(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.linkRef = factory());
}(this, (function () { 'use strict';

function linkRef(component, name) {
	var cache = component._linkedRefs || (component._linkedRefs = {});
	if (!component.refs) component.refs = {};
	return cache[name] || (cache[name] = function (c) {
		component.refs[name] = c;
	});
}

return linkRef;

})));
//# sourceMappingURL=linkref.js.map



//////////////////
// WEBPACK FOOTER
// ./~/linkref/dist/linkref.js
// module id = 4
// module chunks = 0